import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const parkingsApi = createApi({
  reducerPath: "parkingsApi",
  baseQuery: axiosBaseQuerySpotfinder({
    baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
  }),
  tagTypes: ["parkings"],
  endpoints: (builder) => ({
    findAllServiceDetail: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.parkingSpaceLocationController.findAllServiceDetail,
          method: "GET",
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
        };
      },
    }),
    getAllParkingSpaceLocation: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.parkingSpaceLocationController
            .getAllParkingSpaceLocation,
          method: "POST",
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        };
      },
    }),
    findParkingSpaceLocationById: builder.mutation({
      query: (body) => {
        return {
          url: `${spotFinder.parkingSpaceLocationController.findParkingSpaceLocationById}${body.id}/${body.customerId}`,
          method: "GET",
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
        };
      },
    }),
    getAllParkingSpaceLoByLatAndLang: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.parkingSpaceLocationController
            .getAllParkingSpaceLocationByLatLongAndCity,
          method: "POST",
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        };
      },
    }),
    getAllParkingSpaceLocationByLatLongAndCity: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.parkingSpaceLocationController
            .getAllParkingSpaceLocationByLatLongAndCity,
          method: "POST",
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        };
      },
    }),
  }),
});

export const {
  useFindAllServiceDetailMutation,
  useFindParkingSpaceLocationByIdMutation,
  useGetAllParkingSpaceLocationMutation,
  useGetAllParkingSpaceLoByLatAndLangMutation,
  useGetAllParkingSpaceLocationByLatLongAndCityMutation,
} = parkingsApi;
